"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var shared_values_model_1 = require("./shared-values.model");
var default_shared_store_1 = require("./default-shared-store");
function usePrintSharedValues() {
    var store = react_1.useContext(shared_values_model_1.SharedValueContext);
    return function print() {
        var values = getStoreValues(store);
        console.info(values);
    };
}
exports.usePrintSharedValues = usePrintSharedValues;
function getStoreValues(store) {
    var values = {};
    for (var _i = 0, _a = store.allKeys(); _i < _a.length; _i++) {
        var key = _a[_i];
        values[key] = getStoreValue(key, store);
    }
    return values;
}
function getStoreValue(key, store) {
    var value = store.getValue(key);
    return isStore(value) ? getStoreValues(value) : value;
}
function isStore(value) {
    return value instanceof default_shared_store_1.DefaultSharedStore;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHJpbnQtc2hhcmVkLXZhbHVlcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9zaGFyZWQtdmFsdWVzL3ByaW50LXNoYXJlZC12YWx1ZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFBQSwrQkFBaUM7QUFDakMsNkRBQXNFO0FBQ3RFLCtEQUEwRDtBQUUxRCxTQUFnQixvQkFBb0I7SUFDaEMsSUFBTSxLQUFLLEdBQUcsa0JBQVUsQ0FBQyx3Q0FBa0IsQ0FBQyxDQUFDO0lBQzdDLE9BQU8sU0FBUyxLQUFLO1FBQ2pCLElBQU0sTUFBTSxHQUFHLGNBQWMsQ0FBQyxLQUFLLENBQUMsQ0FBQztRQUNyQyxPQUFPLENBQUMsSUFBSSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3pCLENBQUMsQ0FBQztBQUNOLENBQUM7QUFORCxvREFNQztBQUVELFNBQVMsY0FBYyxDQUFDLEtBQWtCO0lBQ3RDLElBQU0sTUFBTSxHQUFHLEVBQUUsQ0FBQztJQUNsQixLQUFrQixVQUFlLEVBQWYsS0FBQSxLQUFLLENBQUMsT0FBTyxFQUFFLEVBQWYsY0FBZSxFQUFmLElBQWUsRUFBRTtRQUE5QixJQUFNLEdBQUcsU0FBQTtRQUNWLE1BQU0sQ0FBQyxHQUFHLENBQUMsR0FBRyxhQUFhLENBQUMsR0FBRyxFQUFFLEtBQUssQ0FBQyxDQUFDO0tBQzNDO0lBRUQsT0FBTyxNQUFNLENBQUM7QUFDbEIsQ0FBQztBQUVELFNBQVMsYUFBYSxDQUFDLEdBQVcsRUFBRSxLQUFrQjtJQUNsRCxJQUFNLEtBQUssR0FBRyxLQUFLLENBQUMsUUFBUSxDQUFDLEdBQUcsQ0FBQyxDQUFDO0lBQ2xDLE9BQU8sT0FBTyxDQUFDLEtBQUssQ0FBQyxDQUFDLENBQUMsQ0FBQyxjQUFjLENBQUMsS0FBSyxDQUFDLENBQUMsQ0FBQyxDQUFDLEtBQUssQ0FBQztBQUMxRCxDQUFDO0FBRUQsU0FBUyxPQUFPLENBQUMsS0FBVTtJQUN2QixPQUFPLEtBQUssWUFBWSx5Q0FBa0IsQ0FBQztBQUMvQyxDQUFDIn0=